<app-loading-spinner
  *ngIf="isLoading"
  style="text-align: center"
/>

<form
  [formGroup]="loginForm"
  class="login-form"
  *ngIf="!isLoading"
>
  <app-text-input
    label="Email"
    [control]="$any(loginForm.get('email'))"
    placeholder="Enter your email"
  >
    <span error>Email is required and must be valid</span>
  </app-text-input>

  <app-text-input
    label="Code"
    type="code"
    [control]="$any(loginForm.get('code'))"
    placeholder="Enter your code"
  >
    <span error>Code is required</span>
  </app-text-input>

  <div
    style="text-align: center"
    *ngIf="isCodeSent"
  >
    By logging into this site you agree to our

    <a href="https://zippmat.com/terms.html"> Terms and Conditions </a>
    and <a href="https://zippmat.com/privacy-policy.html">Privacy Policy</a>
  </div>

  <button
    mat-raised-button
    color="primary"
    type="submit"
    (click)="onSubmit()"
    [disabled]="loginForm.invalid"
  >
    <span *ngIf="isCodeSent"> Log In </span>

    <span *ngIf="!isCodeSent"> Send Code </span>
  </button>

  <div
    class="code-sent"
    *ngIf="isCodeSent"
  >
    Please check email for login OTP.
  </div>

  <div
    class="error"
    *ngIf="error"
  >
    {{ error }}
  </div>

  <button
    mat-raised-button
    color="primary"
    (click)="onRegister()"
    class="register-button"
  >
    Register
  </button>
</form>
